var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('list-page',{attrs:{"columns":_vm.columns,"headers":_vm.headers,"sort":"id","descending":true,"title":"Task Scheduler List","icon":"mdi-folder-network","show-add-button":false,"stateendpoint":"taskScheduler.taskSchedulers","show-default-action-buttons":false,"actions":_vm.actions,"action-buttons":_vm.actionButton}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }